
import { defineComponent, computed, PropType } from 'vue'
import { AchievementLevel } from '@/types'
import { formatPrice } from '@/lib/formatters'

export default defineComponent({
  props: {
    itemName: {
      type: String,
      required: true
    },
    achievementLevels: {
      type: Array as PropType<AchievementLevel[]>,
      required: true
    }
  },
  setup (props) {
    const table = computed(() => {
      return [1, 2, 3].map(screenCount => ({
        screenCount,
        thresholds: props.achievementLevels.filter(level => level.screenCount === screenCount)
      }))
    })

    return { table, formatPrice }
  }
})
